import { Avatar, Style } from '@dicebear/core'
import gaze from '@dicebear/styles/gaze.json'

// Who did something — a person or an AI conversation — as a small generated
// avatar (DiceBear "Gaze"), seeded by their id: the same for every viewer and
// every device. Nobody picks it. If avatars ever become a choice, store the
// seed (initially the id) on the user and the session.

/** Soft backgrounds from the app's palette, saturation down 45%: quiet next to cards and messages. */
const MUTED_SOFT = ['e0ddf2', 'cee2dc', 'ecdbd0', 'd8dfee', 'e9dae5', 'e4ddc8']

const style = new Style(gaze)
const cache = new Map<string, string>()

/** The avatar for `seed` as a data URI (memoised: it never changes). */
export function avatarUri(seed: string): string {
  let uri = cache.get(seed)
  if (!uri) {
    uri = new Avatar(style, { seed, borderRadius: 50, backgroundColor: MUTED_SOFT }).toDataUri()
    cache.set(seed, uri)
  }
  return uri
}
